var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIconApi101Static(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API101_newStatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API101_newStatic",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9E8F6",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(13.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4848617,64.4983964 L106.618864,81.9382232 L155.752865,64.4983964 C166.728862,76.2955524 173.433161,92.0550062 173.433161,109.366165 C173.433161,110.473788 173.405715,111.575059 173.35146,112.669346 C171.614542,101.339824 142.401645,92.32509 106.618864,92.32509 C70.8360823,92.32509 41.623185,101.339824 39.8862676,112.669346 C39.832012,111.575059 39.8045656,110.473788 39.8045656,109.366165 C39.8045656,92.0550062 46.5088653,76.2955524 57.4848618,64.4983964 Z",
    id: "Combined-Shape",
    fill: "#B49859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#B49859",
    points: "106.618864 0.103177239 212.833024 37.803273 106.618864 75.5033687 0.404702637 37.803273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.055311,35.4580166 L39.8045656,55.1947447",
    id: "Line",
    stroke: "#003A5D",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(34.304566, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19194106,0.657373247 L5.19194106,76.6277464",
    id: "Line-2",
    stroke: "#003A5D",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#003A5D",
    cx: 5.19194106,
    cy: 19.8755605,
    rx: 5.19194106,
    ry: 6.19904866
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19194106,79.3864276 C8.05937092,79.3864276 10.3838821,76.611019 10.3838821,73.187379 C10.3838821,69.7637389 8.05937092,23.1545782 5.19194106,23.1545782 C2.32451119,23.1545782 0,69.7637389 0,73.187379 C0,76.611019 2.32451119,79.3864276 5.19194106,79.3864276 Z",
    id: "Oval-Copy",
    fill: "#003A5D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIconApi101Static);
export default __webpack_public_path__ + "static/media/API_icon_API101_Static.32e718e2831c2be445ed471e5372ccac.svg";
export { ForwardRef as ReactComponent };